// Lucky Corner Fish & Chips — official 2026 menu
export const CONTACT = {
  name: "Lucky Corner Fish & Chips",
  address: "65 Mitcham Rd, Donvale VIC 3111",
  suburb: "Donvale, Victoria",
  phone: "(03) 8828 9658",
  phoneHref: "tel:+61388289658",
  website: "www.luckycornerfc.com.au",
  websiteHref: "https://www.luckycornerfc.com.au",
  orderUrl: "https://luckycorner.orderfoods.com.au/h5/#/pages/shop/shop?sid=3356",
  established: "Donvale",
  hours: [
    { day: "Mon – Thu", time: "11:00 — 20:30" },
    { day: "Friday", time: "11:00 — 21:00" },
    { day: "Saturday", time: "11:00 — 21:00" },
    { day: "Sunday", time: "11:30 — 20:30" },
  ],
};

export const MENU = [
  {
    id: "gyros",
    no: "01",
    title: "Souvlaki & Gyros",
    tagline: "A little Greek soul in every serve.",
    highlight: "Our Signature",
    strong: true,
    items: [
      { name: "Gyros Wrap — Lamb / Chicken / Mix (XL)", desc: "Lettuce, tomato, onion, tzatziki", price: "19.9" },
      { name: "Gyros Wrap — Lamb or Mix", desc: "Tomato, onion, tzatziki, chips", price: "17.5" },
      { name: "Gyros Wrap — Chicken", desc: "Tomato, onion, tzatziki, chips", price: "17.5" },
      { name: "Lucky Corner Gyros", desc: "Lamb/chicken/mix, lettuce, tomato, onion, egg, cheese, tzatziki, chips", price: "22.9" },
      { name: "Fish Souvlaki", desc: "Lettuce, tomato, onion, tzatziki, chips", price: "19" },
      { name: "Calamari Souvlaki", desc: "Lettuce, tomato, onion, tarama sauce, chips", price: "18.9" },
      { name: "Veggie Souvlaki", desc: "Lettuce, tomato, onion, egg, cheese, tzatziki", price: "12" },
      { name: "Gyros Container — Chicken", desc: "Small / Large", price: "$20 / $45" },
      { name: "Gyros Container — Lamb or Mix", desc: "Small / Large", price: "$25 / $50" },
    ],
    note: "Dips (tzatziki, tirokafteri, tarama, mustard) $3 · Extra meat $3 · Gluten-free pita $3.",
  },
  {
    id: "fish",
    no: "02",
    title: "Fish",
    tagline: "Battered or grilled, cooked fresh to order.",
    highlight: "House Favourite",
    items: [
      { name: "Deep Sea Cod", desc: "", price: "10" },
      { name: "Flake", desc: "The classic Aussie favourite", price: "12" },
      { name: "Junior Flake", desc: "Smaller serve", price: "8.5" },
      { name: "Blue Grenadier", desc: "Mild & flaky", price: "12" },
      { name: "Whiting", desc: "Sweet, delicate fillet", price: "12" },
      { name: "Barramundi", desc: "Firm Australian favourite", price: "14" },
      { name: "Salmon", desc: "Rich Atlantic fillet", price: "14.9" },
      { name: "Flake Fingers", desc: "Crispy goujons", price: "$2 ea · $11.50 / 6" },
    ],
    note: "Grilled — battered, crumbed or gluten-free — add $0.50.",
  },
  {
    id: "seafood",
    no: "03",
    title: "Seafood & Calamari",
    tagline: "Clean, fresh seafood — never frozen.",
    items: [
      { name: "Seafood Stick", desc: "", price: "2.5" },
      { name: "Prawns", desc: "Golden battered", price: "3.5" },
      { name: "Scallops", desc: "Crumbed & golden", price: "3.8" },
      { name: "Seafood Skewer", desc: "", price: "12" },
      { name: "Prawn Skewer", desc: "", price: "12" },
      { name: "Mussels", desc: "", price: "$1.50 ea · $8.50 / 6" },
      { name: "Calamari Rings", desc: "", price: "$2 ea · $11.90 / 6" },
      { name: "Calamari Salt & Pepper", desc: "", price: "$2 ea · $11.90 / 6" },
    ],
    note: "Grilled — battered, crumbed or gluten-free — add $0.50.",
  },
  {
    id: "burgers",
    no: "04",
    title: "Burgers",
    tagline: "Stacked, saucy, made to order.",
    items: [
      { name: "Plain Burger", desc: "Patty, lettuce, tomato sauce", price: "9.9" },
      { name: "The Lot", desc: "Patty, lettuce, tomato, onion, egg, bacon, cheese, tomato sauce", price: "18" },
      { name: "Lucky Corner", desc: "Lettuce, onion, tomato, pickles, beetroot, pineapple, egg, bacon, mayo-mustard", price: "18.5" },
      { name: "Gyros Burger", desc: "Chicken or lamb, lettuce, tomato, onion, egg, cheese, tzatziki", price: "18.9" },
      { name: "Chicken Fillet", desc: "Lettuce, tomato, mayo sauce", price: "16" },
      { name: "Schnitzel", desc: "Lettuce, tomato, mayo & sweet chilli sauce", price: "16" },
      { name: "Fish Panko", desc: "Flake fingers, lettuce, tartar sauce", price: "14" },
      { name: "Calamari", desc: "Lettuce, tomato, tarama sauce", price: "13" },
      { name: "Veggie", desc: "Veggie patty, lettuce, tomato, tomato sauce", price: "12" },
    ],
    note: "Extras — bacon, egg, pickles, pineapple, beetroot or cheese $1.50 · meat patty $6 · chicken fillet or schnitzel $8.90.",
  },
  {
    id: "sandwiches",
    no: "05",
    title: "Sandwiches",
    tagline: "Scotch fillet & classic rolls.",
    items: [
      { name: "Egg & Bacon Roll", desc: "2 egg, 2 bacon", price: "7.5" },
      { name: "Steak Plain", desc: "Scotch fillet, lettuce, tomato sauce", price: "14" },
      { name: "Steak Lot", desc: "Scotch fillet, lettuce, tomato, onion, egg, bacon, cheese, tomato sauce", price: "19.9" },
    ],
  },
  {
    id: "plates",
    no: "06",
    title: "Dinner Plates",
    tagline: "Sit-down feasts, Greek taverna style.",
    items: [
      { name: "Open Gyros Plate — for 1", desc: "Lamb/chicken/mix, chips, Greek salad, tzatziki, Greek pita", price: "27.9" },
      { name: "Open Gyros Plate — for 2", desc: "Lamb/chicken/mix, chips, Greek salad, tzatziki, tirokafteri, saganaki, Greek pita", price: "69.9" },
      { name: "Skewer Plate — for 1", desc: "1 lamb & 1 chicken skewer, chips, Greek salad, tzatziki, Greek pita", price: "28" },
      { name: "Skewer Plate — for 2", desc: "2 lamb & 2 chicken skewers, chips, Greek salad, tzatziki, tirokafteri, saganaki, Greek pita", price: "69.9" },
    ],
  },
  {
    id: "packs",
    no: "07",
    title: "Meal Packs",
    tagline: "Feed one, or feed the whole street.",
    items: [
      { name: "Kids Pack", desc: "Chips, 2 chicken nuggets, 3 flake fingers, kids drink", price: "14" },
      { name: "Pack for One", desc: "Chips, 1 dim sim, 1 potato cake, 1 fish of the day", price: "18.5" },
      { name: "Pack for Two", desc: "Chips, 2 dim sims, 2 potato cakes, 2 fish of the day", price: "35.9" },
      { name: "Family Pack", desc: "Chips, 4 dim sims, 4 potato cakes, 4 fish of the day", price: "64.5" },
      { name: "Grilled Fish Pack", desc: "Grilled fish of the day, chips or rice, Greek salad or coleslaw", price: "22" },
      { name: "Calamari Salt & Pepper Pack", desc: "6 calamari, chips, Greek salad", price: "22" },
      { name: "Burger Pack", desc: "Burger with the lot, chips, 375ml drink", price: "24.5" },
      { name: "Souvlaki Pack", desc: "Lamb/chicken/mix, chips, 375ml drink", price: "28" },
      { name: "Hellenic Snack Pack", desc: "Lamb/chicken/mix, chips, tzatziki, BBQ & tomato sauce, feta", price: "24" },
      { name: "Skewer Pack", desc: "1 lamb or chicken skewer, Greek pita bread", price: "8" },
    ],
    note: "Fish packs use fish of the day — extra charge applies for other fish selections.",
  },
  {
    id: "snacks",
    no: "08",
    title: "Snacks & Sides",
    tagline: "The little extras that matter.",
    items: [
      { name: "Potato Cake", desc: "", price: "2.2" },
      { name: "Dim Sim", desc: "Steamed or fried", price: "2.2" },
      { name: "South Melbourne Dim Sim", desc: "The famous one", price: "4" },
      { name: "Chicken Croquette", desc: "", price: "2.8" },
      { name: "Fish Cake", desc: "", price: "3.8" },
      { name: "Battered Sausage", desc: "", price: "3.5" },
      { name: "Spring Roll", desc: "", price: "4" },
      { name: "Chiko Roll", desc: "", price: "4" },
      { name: "Corn Jack", desc: "", price: "4" },
      { name: "Pickled Onion", desc: "", price: "2.9" },
      { name: "Saganaki", desc: "Pan-fried Greek cheese", price: "13" },
      { name: "Greek Pita Bread", desc: "", price: "3" },
      { name: "Chicken Nuggets", desc: "", price: "$1.20 ea · $7 / 6" },
      { name: "Onion Rings", desc: "", price: "$1 ea · $5.80 / 6" },
    ],
  },
  {
    id: "sides",
    no: "09",
    title: "Salads & Chips",
    tagline: "Golden, fresh & Greek.",
    items: [
      { name: "Greek Salad", desc: "Small / Large", price: "$14 / $16" },
      { name: "Coleslaw", desc: "Small / Large", price: "$14 / $16" },
      { name: "Beetroot Salad", desc: "Small / Large", price: "$14 / $16" },
      { name: "Steamed Rice", desc: "", price: "5" },
      { name: "Steamed Greens", desc: "", price: "7.5" },
      { name: "Chips", desc: "Minimum / Large / Family", price: "$7.60 / $9.90 / $13" },
      { name: "Greek Style Chips", desc: "With feta & oregano", price: "11" },
      { name: "Sweet Potato Chips", desc: "One size", price: "8" },
    ],
  },
  {
    id: "sweets",
    no: "10",
    title: "Sweets",
    tagline: "A sweet Greek finish.",
    items: [
      { name: "Pineapple or Banana Fritter", desc: "Battered & golden", price: "4" },
      { name: "Apple Pie", desc: "", price: "3.5" },
      { name: "Greek Bougatsa", desc: "Greek custard pie", price: "3.5" },
      { name: "Loukoumades", desc: "Greek donuts — add sugar, cinnamon, Biscoff, honey, chocolate or walnuts", price: "12" },
    ],
  },
];
